import { AppliedFilters, FormValues } from './types';

export const convertFormValuesToAppliedFilters = (formValues: FormValues): AppliedFilters => Object.values(formValues);
